import { getCurrentUserToken } from "@/lib/auth";
import fetchUserPlan from "@/lib/pricing/fetchUserPlan";
import { TPricingVersion } from "@/types/plan-data";
import { useQuery } from "@tanstack/react-query";
import { useSigninCheck } from "reactfire";

export const USER_PLAN_QUERY_KEY = "user-plan-data";

const useUserPlanData = (version?: TPricingVersion) => {
  const { data: signinData } = useSigninCheck();

  const query = useQuery({
    queryKey: [USER_PLAN_QUERY_KEY],
    queryFn: async () => {
      const token = await getCurrentUserToken();

      if (!token) throw new Error("No authentication token");

      const planData = await fetchUserPlan(token, version);

      if (!planData) throw new Error("Failed to fetch user plan");

      return planData;
    },
    enabled: !!signinData?.signedIn,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 0,
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useUserPlanData;
